
import IftaLabel from 'primevue/iftalabel';
import Button from 'primevue/button';
import { computed, onMounted, ref } from 'vue';
import InputText from 'primevue/inputtext';
import { customer } from '../apis/customer';
import { CustomerBonus, CustomerBonusDetail, CustomerBonusList } from '../types/customer';
import { useAuthStore } from '../stores/auth';
import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import Tag from 'primevue/tag';
import { formatCurrency } from '../utils/currency';
import { useWebStore } from '../stores/web';
import { formatThaiDateTime } from '../utils/date';
import Card from 'primevue/card';
import ConfirmPopup from 'primevue/confirmpopup';
import { useConfirm } from 'primevue';
import { useToast } from 'primevue/usetoast';
import Toast from 'primevue/toast';
import Paginator from 'primevue/paginator';
import { main_wallet } from '../apis/main_wallet';

export default {
	name: 'PromotionBonus',
	methods: { formatThaiDateTime, formatCurrency },
	components: {
		IftaLabel,
		InputText,
		Button,
		DataTable,
		Column,
		Dialog,
		Tag,
		Card,
		ConfirmPopup,
		Toast,
		Paginator,
	},
	setup() {
		const auth = useAuthStore();

		const web = useWebStore();

		const toast = useToast();
		const confirm = useConfirm();

		onMounted(() => {
			auth.fetchData();
			auth.hydrate();
			web.hydrate();
			handleGetBonus();
		});

		const visible = ref(false);
		const dialogLoading = ref(false);
		const first = ref(0);
		const rows = ref(10);

		const tableLoading = ref(false);
		const bonus = ref<CustomerBonusList[]>([]);
		const bonusTotal = ref<number>(0);

		const bonusList = computed(() => {
			return bonus.value.filter((b) => b.status === 'PENDING');
		});

		const totalRecords = computed(() => bonusList.value.length);

		const bonusConfirm = ref<CustomerBonusList | null>(null);
		const bonusReference = ref('');

		const handleGetBonus = async () => {
			tableLoading.value = true;
			try {
				const payload = {
					page: Math.floor(first.value / rows.value) + 1,
					size: rows.value,
				};

				const resp = await customer.getBonus(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}
				if (resp.code !== '0') throw new Error(resp.message);

				const result = resp.result as CustomerBonus;

				bonus.value = result.list || [];
				bonusTotal.value = result.total;
			} catch (error) {
				toast.add({
					severity: 'error',
					summary: 'เกิดข้อผิดพลาดบางอย่าง',
					detail: String(error),
					life: 3000,
				});
			} finally {
				tableLoading.value = false;
			}
		};

		const clickReceiveBonus = async (event: any, item: CustomerBonusList) => {
			if (item.status !== 'PENDING') {
				toast.add({
					severity: 'warn',
					summary: 'ไม่สามารถรับโบนัสนี้ได้',
					detail: 'สถานะโบนัสไม่ใช่รอดำเนินการ',
					life: 3000,
				});
				return;
			}

			bonusConfirm.value = item;
			dialogLoading.value = true;
			visible.value = true;

			try {
				const payload = { serial: item.serial };
				const resp = await customer.getBonusDetail(payload);

				if (resp.code !== '0') throw new Error(resp.message);

				const result = resp.result as CustomerBonusDetail;
				bonusReference.value = result.reference;
			} catch (error: any) {
				toast.add({
					severity: 'error',
					summary: 'ไม่สามารถโหลดข้อมูลโบนัส',
					detail: String(error),
					life: 3000,
				});
				visible.value = false;
			} finally {
				dialogLoading.value = false;
			}
		};

		const receiveBonus = async () => {
			if (!bonusConfirm.value) return;

			try {
				const payload = {
					serial: bonusConfirm.value.serial,
					reference: bonusReference.value,
				};

				const resp = await main_wallet.receiveBonus(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				await handleGetBonus();
				await auth.fetchData();
				auth.hydrate();
				visible.value = false;

				toast.add({
					severity: 'success',
					summary: 'สำเร็จ',
					detail: 'รับโบนัสเรียบร้อยแล้ว',
					life: 3000,
				});
			} catch (error) {
				toast.add({
					severity: 'error',
					summary: 'เกิดข้อผิดพลาด',
					detail: String(error),
					life: 3000,
				});
			}
		};

		const onPageChange = (event: any) => {
			first.value = event.first;
			rows.value = event.rows;
			handleGetBonus();
		};



		return {
			visible,
			dialogLoading,
			tableLoading,
			bonusList,
			totalRecords,
			bonusConfirm,
			first,
			rows,
			clickReceiveBonus,
			receiveBonus,
			onPageChange,
			formatThaiDateTime,
			formatCurrency,
		};
	},
};
